import React from 'react';
import { Lock, Minus, Plus, Unlock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const DimensionsSection = ({
  width,
  height,
  naturalWidth,
  naturalHeight,
  aspectRatioLocked,
  onToggleAspectRatio,
  handleWidthChange,
  handleHeightChange,
  startHoldIncrement,
  stopHoldIncrement,
  incrementWidth,
  decrementWidth,
  incrementHeight,
  decrementHeight,
  maxWidth,
  maxHeight,
}) => (
  <div className="space-y-3">
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-sm">Dimensiones</h3>
      <Button
        variant="ghost"
        size="sm"
        className={`h-6 w-6 p-0 ${aspectRatioLocked ? 'text-sky-600 dark:text-sky-400' : 'text-slate-400'}`}
        onClick={onToggleAspectRatio}
        title={aspectRatioLocked ? 'Desbloquear relación de aspecto' : 'Bloquear relación de aspecto'}
      >
        {aspectRatioLocked ? <Lock className="w-3 h-3" /> : <Unlock className="w-3 h-3" />}
      </Button>
    </div>

    <div className="space-y-3">
      <div className="space-y-2">
        <Label htmlFor="panel-width" className="text-xs">
          Ancho (px){' '}
          {naturalWidth && !width && <span className="text-slate-500 dark:text-slate-400">• Original: {naturalWidth}</span>}
        </Label>
        <div className="flex gap-2 items-center">
          <Button
            variant="outline"
            size="sm"
            className="h-9 w-9 p-0"
            onMouseDown={() => startHoldIncrement(() => decrementWidth(10))}
            onMouseUp={stopHoldIncrement}
            onMouseLeave={stopHoldIncrement}
            onTouchStart={() => startHoldIncrement(() => decrementWidth(10))}
            onTouchEnd={stopHoldIncrement}
          >
            <Minus className="w-4 h-4" />
          </Button>
          <Input
            id="panel-width"
            type="number"
            min="50"
            max={maxWidth}
            value={width}
            onChange={handleWidthChange}
            placeholder={naturalWidth ? `Original: ${naturalWidth}` : 'Ancho'}
            className="flex-1"
          />
          <Button
            variant="outline"
            size="sm"
            className="h-9 w-9 p-0"
            onMouseDown={() => startHoldIncrement(() => incrementWidth(10))}
            onMouseUp={stopHoldIncrement}
            onMouseLeave={stopHoldIncrement}
            onTouchStart={() => startHoldIncrement(() => incrementWidth(10))}
            onTouchEnd={stopHoldIncrement}
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
        <p className="text-xs text-slate-500 dark:text-slate-400">
          El alto se ajusta solo; para cambiarlo arrastra los círculos de la imagen.
        </p>
      </div>
    </div>
  </div>
);

export default DimensionsSection;
